import "./home.scss";
import useResizeObserver from "@react-hook/resize-observer";
import { FC, ReactElement, useEffect, useMemo, useRef, useState } from "react";
import { useResizeTools } from "../../utils/resize-hooks";
import { Dashboard, findAuctionIndex, useContract } from "../../web3/web3-hooks";
import Connector from "../../components/connector";
import HomePanel from "../../components/HomePanel";
import { If } from "../../components/control";
import { STAGES, int } from "../../types";
import { BigNumber, utils } from "ethers";
import previewMp4 from "../../assets/mint/preview.mp4";

import "./home-panel.scss";

import { RoundInfoBox } from "./components/RoundInfo";
import { CountSelector } from "./components/CountSelector";
import LeftProgress from "./components/LeftProgress";
import { RevealPanel } from "./components/Reveal/RevealPanel";
import React from "react";

function Home() {
  const { setSize } = useResizeTools();
  let homeRef = useRef<HTMLDivElement | null>(null);
  const [revealVisible, toggleReveal] = useState(false);
  const {
    active,
    dashboard,
    userSelectCount,
    setUserSelectCount,
    currentPrice,
    currentMaxCount,
    userWhiteList,
    mint,
  } = useContract(60 * 1000);

  // const currentTotal =
  //   parseFloat(utils.formatEther(currentPrice)) * userSelectCount;

  const currentTotal = utils.formatEther(BigNumber.from(currentPrice).mul(userSelectCount));

  useResizeObserver(homeRef, setSize);

  const stage = dashboard
    ? BigNumber.from(dashboard.currentStage).toNumber()
    : 0;

  const finished = true;

  const homePanelContent: ReactElement | null = active ? (
    <>
      <div className="home-panel-top-row">
        <RoundInfoBox dashboard={dashboard!!} stage={stage}></RoundInfoBox>
      </div>
      <div className="nft-preview--before">
        <video src={previewMp4} muted autoPlay playsInline loop></video>
      </div>
      <CountSelector
        max={currentMaxCount}
        selected={userSelectCount}
        onSelect={setUserSelectCount}
      ></CountSelector>
      {/* 下方价格和供给 */}
      <div className="home-panel-bottom-price-wrap">
        <div className="price-data">
          PRICE: {utils.formatEther(currentPrice)}
        </div>
        <div className="price-data">TOTAL: {currentTotal}</div>
      </div>
    </>
  ) : null;

  return (
    <div className="home-page" ref={homeRef}>
      <div className="link-homepage" onClick={()=>{
        window.open('https://www.sofanft.io')
      }}></div>
      {/* 左侧进度条 */}
      {/* <LeftProgress stage={stage}></LeftProgress> */}
      {/* 连接器 */}
      <Connector userWhiteList={userWhiteList} />
      {/* 主体 */}
      <If value={active && dashboard != null && !finished}>
        <HomePanel>
          {homePanelContent}
          <div className="mint-btn-box" onClick={mint}>
            <div className="mint-btn-inner">MINT</div>
            <div className="mint-btn-top"></div>
            <div className="mint-btn-top-02"></div>
            <div className="mint-btn-top-shadow"></div>
          </div>
        </HomePanel>
      </If>
      <If value={active && dashboard != null && finished}>
        <HomePanel className="finished">
        </HomePanel>
      </If>
      {/* 主体 */}
      <If value={!active}>
        <div className="home-link-panel-wrap">
          <div className="home-link-panel--title">PLEASE CONNECT WALLET</div>
          <div className="home-link-panel--img"></div>
        </div>
      </If>
      <If value={active && dashboard != null}>
        <div
          className="reveal-entry-btn"
          onClick={() => toggleReveal(true)}
        ></div>
        <If value={revealVisible}>
          <RevealPanel onClose={() => toggleReveal(false)}></RevealPanel>
        </If>
      </If>
    </div>
  );
}

export default React.memo(Home);
